import axios from 'axios';
import { baseURL } from '../utility/Constants';
import { processErrorData } from '../utils/errorDataProcessor';

export const fetchErrorMetrics = async (emsName, timeFilter, date) => {
  try {
    const formattedDate = new Date(date).toISOString();
    const payload = {
      emsName,
      timeFilter,
      date: formattedDate
    };

    const response = await axios.post(`${baseURL}/error-metrics`, payload);
    
    const errorData = response.data.data.map(row => {
      // Process each row's error data
      const errors = {
        ErrorMsg: row.ErrorMsg,
        ErrorMsg2: row.ErrorMsg2,
        R_Err1: row.Rec?.R_Err1 || 0,
        R_Err2: row.Rec?.R_Err2 || 0,
        Err: row.Inv?.Err || 0
      };

      const messages = processErrorData(errors);
      return {
        ...row,
        errorMessages: {
          ErrorMsg: messages.bmsErrorMessage,
          ErrorMsg2: messages.bmsError2Message,
          R_Err1: messages.rectifierError1Message,
          R_Err2: messages.rectifierError2Message,
          Err: messages.inverterErrorMessage
        }
      };
    });
    return {
      ...response.data,
      data: errorData
    };

  } catch (error) {
    console.error('Error fetching error metrics:', {
      message: error.message,
      response: error.response?.data,
      payload: {
        emsName,
        timeFilter,
        date: date?.toString()
      }
    });
    throw error;
  }
};
